// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wcc-heatmap__offset-viewer{position:relative;display:block;background-color:#000;border-radius:3px}.wcc-heatmap__offset-viewer__frame__inner{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;justify-content:center;align-items:center}.wcc-heatmap__offset-viewer__frame{position:absolute;border:1px solid #f8f8f7;border-radius:3px}", ""]);
// Exports
module.exports = exports;
